<template>
  <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
    <template #button-content>
      <vue-notification-system :size="20" :count="type0.length + type_status.length" counterLocation="upperRight"
        counterStyle="round" counterBackgroundColor="#ff4d00" counterTextColor="#FFFFFF" iconColor="#FFFFFF" />
    </template>
    <div class="notification-box">
      <div class="notification-box-header">
        <div class="notification-box-header-left">Thông báo</div>
        <div class="notification-box-header-right">Mới: {{ type0.length + type_status.length }}</div>
      </div>
      <div class="notification-box-list">
        <b-link class="notification-item" v-for="type0 in type0" :key="type0.id" @click='postExam(type0.id)'
          :to="{ name: 'exam-result', params: { id: type0.id_log_exam }, }">
          <div class="notification-thumb">
            <img class="image-thumb" src="@/assets/favicon.png" alt="HSK Online" />
          </div>
          <div class="notify">{{ type0.name_exam }} đã được chấm điểm</div>
        </b-link>
        <div v-for="status in status" :key="`status1-${status.id}`">
          <div v-if="status.type == '0'">
            <b-link class="notification-item" @click='postNew(status.id)' :to="status.slug_new">
              <div class="notification-thumb">
                <img class="image-thumb" src="@/assets/favicon.png" alt="HSK Online" />
              </div>
              <div class="notify">{{ status.title_new }}</div>
            </b-link>
          </div>
        </div>
        <div v-for="status in status" :key="`status2-${status.id}`">
          <div v-if="status.type == '1'">
            <b-link class="notification-item" :to="status.slug_new">
              <div class="notification-thumb">
                <img class="image-thumb" src="@/assets/favicon.png" alt="HSK Online" />
              </div>
              <div class="notify">{{ status.title_new }}</div>
            </b-link>
          </div>
        </div>
        <b-link class="notification-item" v-for="type1 in type1" :key="type1.id"
          :to="{ name: 'exam-result', params: { id: type1.id_log_exam }, }">
          <div class="notification-thumb">
            <img class="image-thumb" src="@/assets/favicon.png" alt="HSK Online" />
          </div>
          <div class="notify">{{ type1.name_exam }} đã được chấm điểm</div>
        </b-link>
      </div>
    </div>
  </b-dropdown>
</template>

<script>
import VueNotificationSystem from "vue-notification-bell";
import axios from "axios";
import { APP_CONFIG } from "@/utils/constants";

export default {
  name: "Notify",
  components: {
    VueNotificationSystem,
  },

  data() {
    return {
      id: this.$route.params.id,
      type0: [],
      type1: [],
      status: null,
      type_status: []
    };
  },
  mounted() {
    axios
      .get(`${APP_CONFIG.apiUrl}/thong-bao/type_status`)
      .then((response) => (this.type_status = response.data));
    axios
      .get(`${APP_CONFIG.apiUrl}/thong-bao/status`)
      .then((response) => (this.status = response.data));
    //lấy nhưng thông báo có type = 0
    axios
      .get(`${APP_CONFIG.apiUrl}/thong-bao/type0`)
      .then((response) => (this.type0 = response.data));
    //lấy nhưng thông báo có type = 1
    axios
      .get(`${APP_CONFIG.apiUrl}/thong-bao/type1`)
      .then((response) => (this.type1 = response.data));
  },
  methods: {
    postExam(id) {
      axios.get(`${APP_CONFIG.apiUrl}/thong-bao/post_exam/${id}`)
        .then(response => {
          console.log(response)
        })
    },
    postNew(id) {
      axios.get(`${APP_CONFIG.apiUrl}/thong-bao/post_new/${id}`)
        .then(response => {
          console.log(response)
        })
      window.setTimeout(() => {
        window.location.reload(true);
      }, 200);
    },
  },
};
</script>

<style>
.notification-box-header {
  display: flex;
  justify-content: space-between;
  padding: 5px 10px 10px 10px;
  border-bottom: 1px solid #e0e0e0;
}

.notification-item {
  display: flex;
  align-items: center;
  width: 350px;
  padding: 10px;
  gap: 10px;
  border-bottom: 1px solid #e0e0e0;
  color: #000;
}

.notification-thumb {
  width: 40px;
}

.notification-thumb img {
  width: 100%;
}

.notification-item .notify {
  flex: 1;
}
</style>